module.exports = __webpack_public_path__ + "static/img/rsdashboard_icon.46497de6.png";